import React, { useEffect, useMemo, useState } from "react";
import BreadCrumsHeader from "../../common/BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";
import Pagination from "../../common/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../common/Loader";
import SearchBar from "../../common/SearchBar";
import { getUserById, getUsers } from "../../../services/adminService";
import debounce from "lodash.debounce";
import DetailsModal from "../../common/DetailsModal";
import PopupContent from "./PopupContent";
import { Dropdown } from "antd";
import FilterPanel from "../../common/FilterPanel";
import { DatePicker } from "antd";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
// Removed fundraiser and merchant filters from User List
import RedeemedOffers from "./RedeemedOffers";
import FilterButton from "../../common/FilterButton";

const UserListDataTable = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.adminReducer?.loading);
  const [allUsers, setAllUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [statusToggled, setStatusToggled] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  // Removed fundraiser and merchant search queries for User List
  const [open, setOpen] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  // Removed fundraiser and merchant lists for User List
  const [filterParams, setFilterParams] = useState({
    status: null,
    duration: null,
    startDate: null,
    endDate: null,
  });

  const DURATION_MAP = {
    "Today": "DAY",
    "This Week": "WEEK",
    "This Month": "MONTH",
    "This Year": "YEAR",
    "Custom Date": "CUSTOM",
  };
  const [customDate, setCustomDate] = useState([null, null]);

  // Redeemed offer modal state
  const [offerDetailsOpen, setOfferDetailsOpen] = useState(false);
  const [offerDetails, setOfferDetails] = useState(null);

  // Removed fundraiser and merchant debounced searches for User List

  // Removed fundraiser and merchant search handlers

  // Convert filterData to a computed value instead of state
  const filterData = useMemo(
    () => [
      {
        id: "status",
        title: "Subscription Status",
        options: ["Active", "InActive"],
        multiSelect: false,
        valueMap: {
          Active: "active",
          InActive: "inactive",
        },
      },
      {
        id: "duration",
        title: "Time Period",
        options: ["Today", "This Week", "This Month", "This Year", "Custom Date"],
        multiSelect: false,
        valueMap: DURATION_MAP,
        customContent: (selected) => {
          return selected === "Custom Date" ? (
            <div className="mt-3 flex flex-col gap-2">
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-medium text-gray-600">Start Date</label>
                <DatePicker
                  value={customDate?.[0]}
                  onChange={(date) => {
                    const newDates = [date, customDate?.[1]];
                    setCustomDate(newDates);
                  }}
                  style={{ width: '100%' }}
                  placeholder="Start Date"
                  format="YYYY-MM-DD"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-[12px] font-medium text-gray-600">End Date</label>
                <DatePicker
                  value={customDate?.[1]}
                  onChange={(date) => {
                    const newDates = [customDate?.[0], date];
                    setCustomDate(newDates);
                  }}
                  style={{ width: '100%' }}
                  placeholder="End Date"
                  format="YYYY-MM-DD"
                />
              </div>
            </div>
          ) : null;
        }
      },
    ],
    [customDate]
  );

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        acc[filter.id] = filter.defaultValue;
      }
      return acc;
    }, {});
  };

  const [selections, setSelections] = useState(createInitialState(filterData));

  const getUsersData = async (query = "") => {
    console.log('filterParams', filterParams)
    const payload = {
      page: currentPage,
      search: query,
      role: "user",
      status: filterParams?.status,
      duration: filterParams?.duration,
      startDate: filterParams?.startDate,
      endDate: filterParams?.endDate,
    };
    console.log('payload', payload)

    const usersPromise = await dispatch(getUsers(payload))?.unwrap();
    if (usersPromise?.success === true) {
      setAllUsers(usersPromise?.data);
      setCurrentPage(usersPromise?.currentPage);
      setTotalPages(usersPromise?.totalPages);
      setCount(usersPromise?.count);
    }
  };

  useEffect(() => {
    getUsersData(searchQuery);
  }, [statusToggled, currentPage, filterParams]);

  const items = [{ title: "Users" }, { title: "User List" }];

  const columns = [
    { name: "No." },
    { name: "Name" },
    { name: "Date Joined" },
    { name: "Email" },
    { name: "Sub. Amount" },
    { name: "Sub. Status" },
    { name: "Actions" },
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // Scroll to top of user list when changing pages
    const container = document.getElementById('user-list-container');
    if (container) {
      container.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Fallback to window scroll
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((query) => {
        getUsersData(query);
      }, 500),
    []
  );

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    debouncedSearch(value);
  };

  const handleViewDetails = (user) => {
    console.log("View details for user:", user);
  };

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // Removed cleanup for fundraiser and merchant debounced searches

  const fetchUserDetails = async (userId) => {
    try {
      const result = await dispatch(getUserById({ id: userId, silent: true }))?.unwrap();
      if (result?.success) {
        setUserDetails(result.data);
      }
    } catch (e) { console.error(e); }
  };

  const openPopup = async (user) => {
    setUserDetails(null);
    setIsDetailOpen(true);
    if (user?._id) {
      fetchUserDetails(user._id);
    }
  };

  const closePopup = () => {
    setUserDetails(null);
    setIsDetailOpen(false);
  };

  // Removed fundraiser and merchant data fetching and effects for User List

  const handleSelectionChange = (filterId, value) => {
    console.log("handleSelectionChange called");
    console.log("filterData ++>", filterData);
    console.log("filterId ++>", filterId);
    console.log("value ++>", value);
    setSelections((prev) => ({
      ...prev,
      [filterId]: value,
    }));
  };

  const handleReset = () => {
    // handleCancel(); // Keep modal open on reset
    const initialState = createInitialState(filterData);
    setSelections(initialState);
    setFilterParams({
      status: null,
      duration: null,
      startDate: null,
      endDate: null,
    });
    setCustomDate([null, null]);
  };

  const handleApply = () => {
    handleCancel();
    console.log("Applying filters:", selections);

    const mappedFilterParams = {};

    filterData.forEach((filter) => {
      const selectedValue = selections[filter.id];
      if (
        selectedValue !== null &&
        selectedValue !== undefined &&
        selectedValue !== "" &&
        !(Array.isArray(selectedValue) && selectedValue.length === 0)
      ) {
        if (filter.id === "duration" && selectedValue === "Custom Date" && customDate && (customDate[0] || customDate[1])) {
          mappedFilterParams.duration = "CUSTOM";
          mappedFilterParams.startDate = customDate[0]?.format("YYYY-MM-DD");
          mappedFilterParams.endDate = customDate[1]?.format("YYYY-MM-DD");
        } else if (filter.valueMap) {
          mappedFilterParams[filter.id] = filter.multiSelect
            ? selectedValue.map((val) => filter.valueMap[val])
            : filter.valueMap[selectedValue];
        } else {
          mappedFilterParams[filter.id] = selectedValue;
        }
      }
    });
    console.log("Mapped Filter Params:", mappedFilterParams);
    setFilterParams(mappedFilterParams);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  // Callback for PopupContent
  const handleRedeemedOfferClick = (offer) => {
    setIsDetailOpen(false); // Close user modal
    setOfferDetails(offer);
    setOfferDetailsOpen(true); // Open offer details modal
  };

  console.log("userDetails", userDetails);
  return (
    <>
      {loading && <Loader />}
      {isDetailOpen && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          animation: 'fadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)'
        }}>
          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideIn {
                from { transform: translateY(-20px) scale(0.95); opacity: 0; }
                to { transform: translateY(0) scale(1); opacity: 1; }
              }
            `}
          </style>
          <div style={{
            animation: 'slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}>
            <DetailsModal
              handleClose={closePopup}
              content={
                <PopupContent
                  userDetails={userDetails}
                  onRedeemedOfferClick={handleRedeemedOfferClick}
                />
              }
              popupClassName="p-6 w-[335px] sm:w-[540px] md:w-[640px]"
            />
          </div>
        </div>
      )}
      {offerDetailsOpen && (
        <DetailsModal
          handleClose={() => {
            setOfferDetailsOpen(false);
            setIsDetailOpen(true); // Re-open parent modal
          }}
          content={<RedeemedOffers offerDetails={offerDetails} />}
          popupClassName="p-6 w-[335px] sm:w-[600px] md:w-[728px]"
        />
      )}
      <div className="flex flex-col gap-[1rem] md:gap-0 md:flex-row items-start md:items-center justify-between col-span-12">
        <BreadCrumsHeader heading="User List" items={items} search={true} />
        {/* <SearchBar
          parentDivClass="w-[65%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative"
          inputClassName="searchBar w-full mt-[4%] p-3 text-[14px] font-poppins font-[400] outline-none"
          iconClassName="absolute sm:right-[5%] sm:bottom-[25%] lg:right-[3%]"
          placeholder="Search"
          value={searchQuery}
          handleChange={(e) => handleSearchChange(e.target.value)}
        /> */}
      </div>
      <div className="w-full flex justify-between items-center mt-4">
        <SearchBar
          parentDivClass="w-[65%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative"
          inputClassName="searchBar w-full p-3 text-[14px] font-poppins font-[400] outline-none"
          iconClassName="absolute sm:right-[5%] sm:bottom-[25%] lg:right-[3%]"
          placeholder="Search"
          value={searchQuery}
          handleChange={(e) => handleSearchChange(e.target.value)}
        />
        <Dropdown
          overlay={
            <FilterPanel
              filterData={filterData}
              selections={selections}
              handleApply={handleApply}
              handleCancel={handleCancel}
              handleReset={handleReset}
              handleSelectionChange={handleSelectionChange}
            />
          }
          trigger={["click"]}
          open={open}
          onOpenChange={handleOpenChange}
          placement="bottomRight"
          overlayStyle={{
            minWidth: "320px",
            maxHeight: "80vh",
            zIndex: 1000,
          }}
          overlayClassName="filter-dropdown-overlay"
        >
          <FilterButton isOpen={open} />
        </Dropdown>
      </div>
      <div id="user-list-container" className="col-span-12 mt-8">
        <TableContainer style={{ width: "100%", overflowX: "auto" }}>
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {columns.map((column, index) => (
                  <TableCell key={index} className="!text-[#FFFFFF]">
                    {column.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {allUsers.map((user, index) => (
                <TableRow
                  key={index}
                  className="h-[50px]"
                  sx={{
                    boxShadow: "0px 4px 4px 0px #00000040",
                    backgroundColor:
                      (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                  }}
                >
                  <TableCell>{(currentPage - 1) * 50 + index + 1}</TableCell>
                  <TableCell>{user?.name}</TableCell>
                  <TableCell>{formatDate(user?.createdAt)}</TableCell>
                  <TableCell>{user?.email}</TableCell>
                  <TableCell>${user?.subscriptionAmount || "0"}</TableCell>
                  <TableCell>
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium border-[0.5px] ${user?.subscriptionStatus
                        ? "bg-[#50CD8933] text-[#303033] border-[#50CD89]"
                        : "bg-[#BABABA33] text-[#303033] border-[#B1B1B1]"
                        }`}
                    >
                      {user?.subscriptionStatus ? "Active" : "Inactive"}
                    </span>
                  </TableCell>
                  <TableCell>
                    <button
                      className={`flex justify-center items-center border rounded-[6px] p-3 h-[34px] border-[#00ADEF] text-[#00ADEF]`}
                      onClick={() => openPopup(user)}
                    >
                      <span className="font-[600] text-[14px] font-poppins leading-[22px]">
                        View Details
                      </span>
                    </button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default UserListDataTable;
